export enum Roles {
  Admin = 'Admin',
  StudyManager = 'Study Manager',
  Patient = 'Patient',
  Carer = 'Carer'
}
